import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { ViewportScroller } from "@angular/common";

import { IUsaProduct } from "src/app/shared/Models/TopCollectionProduct";
import {
  IExtendPagination,
  PaginatedResult,
} from "src/app/shared/Pagination/IPagination";
import { Observable, Subject } from "rxjs";
import { HomeService } from "src/app/shared/services/home.service";
import { PageEvent } from "@angular/material/paginator";
import {
  ICategoryCollection,
  ISubBrandCollection,
} from "src/app/shared/Models/ICategories";
import { FormControl } from "@angular/forms";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  retry,
  startWith,
  switchMap,
  takeUntil,
  tap,
} from "rxjs/operators";
import { Location, PopStateEvent } from "@angular/common";
import { CategoryService } from "src/app/shared/services/Category.service";
import { Product } from "src/app/shared/classes/product";
import { ProductService } from "src/app/shared/services/product.service";
import { DomSanitizer, SafeHtml, SafeResourceUrl } from "@angular/platform-browser";


@Component({
  selector: 'app-marketProduct',
  templateUrl: './marketProduct.component.html',
  styleUrls: ['./marketProduct.component.scss']
})
export class MarketProductComponent implements OnInit, OnDestroy {
  brandCollectionList$: Observable<PaginatedResult<IUsaProduct[]>>;

  _categoryQuery$: Observable<string>;
  _subCategoryQuery$: Observable<string>;
  _brandQuery$: Observable<string>;
  urlSafe: SafeResourceUrl;

  

  public subBrandCollection: ISubBrandCollection[];

  public products: Product[] = [];
  public brandCollectionList: IUsaProduct[] = [];

  public categoryCollection$: Observable<ICategoryCollection[]>;
  public categoryCollection: ICategoryCollection[] = [];

  searchInputControl: FormControl = new FormControl();
  _unsubscribeAll: Subject<any> = new Subject<any>();

  public grid: string = "col-xl-4 col-md-6";
  public layoutView: string = "grid-view";
  public brands: any[] = [];

  public minPrice: number = 0;
  public maxPrice: number = 2000;

  public sortBy: string; // Sorting Order
  public filterBy: string; // Sorting Order
  public mobileSidebar: boolean = false;
  public loader: boolean = true;

  @Input() pagination: IExtendPagination;
  searchTerm = "";
  resetCategoryWithSubs = false;
  globalSearch ="";

  @Input() categoryName: string;
  @Input() subCategryName: string;
  @Input() brandName: string;
  @Input() minPriceValue: number;
  @Input() maxPriceValue: number;
  @Input() currentPage: number;
  @Input() pageSize: number;
  @Input() orderBy: string;
  @Input() currentPageValue: number;
  @Input() pageSizeValue: number;
  weblink='';
 


  constructor(
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    private _homeService: HomeService,
    private viewScroller: ViewportScroller,
    private location: Location,
    private sanitizer: DomSanitizer,

    private _categoryService:CategoryService,
    public productService: ProductService
  ) {



    
    this.weblink = 'https://www.ebay.com/'+'?rs:embed=true';
    // this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(weblink);
    // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(weblink);
    // this.urlSafe = this.sanitizer.bypassSecurityTrustScript(weblink);
    // this.urlSafe = this.sanitizer.bypassSecurityTrustStyle(weblink);
    // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.weblink);


    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl( this.weblink);



  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  ngOnInit(): void {

  }




  // Mobile sidebar
  toggleMobileSidebar() {
    this.mobileSidebar = !this.mobileSidebar;
  }

  replace(link: any)
  {
    var url = link+ "&output=embed";
      window.location.replace(url);
  }


}
